export function lockDocumentScroll() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return () => {};
  }

  const { body, documentElement } = document;
  const scrollY = window.scrollY;
  const scrollbarGap = window.innerWidth - documentElement.clientWidth;
  const previousStyles = {
    htmlOverflow: documentElement.style.overflow,
    bodyOverflow: body.style.overflow,
    bodyPosition: body.style.position,
    bodyTop: body.style.top,
    bodyLeft: body.style.left,
    bodyRight: body.style.right,
    bodyWidth: body.style.width,
    bodyPaddingRight: body.style.paddingRight,
  };

  documentElement.style.overflow = "hidden";
  body.style.overflow = "hidden";
  body.style.position = "fixed";
  body.style.top = `-${scrollY}px`;
  body.style.left = "0";
  body.style.right = "0";
  body.style.width = "100%";

  if (scrollbarGap > 0) {
    body.style.paddingRight = `${scrollbarGap}px`;
  }

  return () => {
    documentElement.style.overflow = previousStyles.htmlOverflow;
    body.style.overflow = previousStyles.bodyOverflow;
    body.style.position = previousStyles.bodyPosition;
    body.style.top = previousStyles.bodyTop;
    body.style.left = previousStyles.bodyLeft;
    body.style.right = previousStyles.bodyRight;
    body.style.width = previousStyles.bodyWidth;
    body.style.paddingRight = previousStyles.bodyPaddingRight;
    window.scrollTo(0, scrollY);
  };
}
